import React, {useEffect} from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import './index.scss';

const propTypes = {
  anchorEl: PropTypes.any,
  children: PropTypes.node,
  className: PropTypes.any,
  open: PropTypes.bool
};

/** @param {PropTypes.InferProps<typeof propTypes>} props - Component properties. */
export const DropDownMenu = ({className, children, anchorEl, open}) => {
  const [menuOpen, setMenuOpen] = React.useState(false);

  useEffect(() => {
    setMenuOpen(open);
  }, [open]);

  return (
    <div
      className={classnames(
        'ndx-DropDownMenu',
        className,
        anchorEl && menuOpen ? 'open' : 'closed'
      )}>
      {children}
    </div>
  );
};

DropDownMenu.displayName = 'DropDownMenu';

DropDownMenu.propTypes = propTypes;

const menuItemPropTypes = {
  active: PropTypes.bool,
  children: PropTypes.node,
  className: PropTypes.any,
  onClick: PropTypes.func
};

/** @param {PropTypes.InferProps<typeof menuItemPropTypes>} props - Component properties. */
export const MenuItem = ({active, className, children, onClick}) => {
  const handleOnClick = () => onClick();
  return (
    <div
      className={classnames('ndx-MenuItem', className, {active})}
      onClick={handleOnClick}>
      {children}
    </div>
  );
};

MenuItem.displayName = 'MenuItem';

MenuItem.propTypes = menuItemPropTypes;

MenuItem.defaultProps = {
  onClick: function () {}
};

const outsideClickListenerPropTypes = {
  children: PropTypes.node,
  exceptions: PropTypes.array,
  onOutsideClick: PropTypes.func
};

/** @param {PropTypes.InferProps<typeof outsideClickListenerPropTypes>} props - Component properties. */
export const OutsideClickListener = React.forwardRef(
  ({onOutsideClick, children}, ref) => {
    const anchorRef = React.useRef(null);
    const handleOutsideClick = React.useCallback(
      event => {
        if (
          anchorRef &&
          anchorRef.current &&
          !anchorRef.current.contains(event.target) &&
          !ref.some(exc => exc?.current?.contains(event.target))
        ) {
          onOutsideClick();
        }
      },
      [onOutsideClick, ref]
    );
    useEffect(() => {
      document.addEventListener('mousedown', event =>
        handleOutsideClick(event)
      );
    }, [handleOutsideClick]);

    return <div ref={anchorRef}>{children}</div>;
  }
);

OutsideClickListener.displayName = 'OutsideClickListenerOutsideClickListener';

OutsideClickListener.propTypes = outsideClickListenerPropTypes;
